import Modal from "react-modal";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import {
  deleteVehicle,
  resetShowDeleteVehicleConfirmationModal,
  setVehicleToRemove,
} from "../../vehiclesSlice";
import { ReactComponent as Close } from "../../../../assets/images/close.svg";
import { Oval } from "react-loader-spinner";
import toast from "react-hot-toast";

import "./DeleteVehicleConfirmationModal.scss";

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#FFFFFF",
  },
};

export const DeleteVehicleConfirmationModal = () => {
  const dispatch = useAppDispatch();

  const showDeleteVehicleConfirmationModal = useAppSelector(
    (state) => state.vehicles.showDeleteVehicleConfirmationModal
  );
  const deleteVehicleAPI = useAppSelector(
    (state) => state.vehicles.deleteVehicle
  );

  const isOpen = showDeleteVehicleConfirmationModal ? true : false;

  React.useEffect(() => {
    if (!deleteVehicleAPI.loading && !!deleteVehicleAPI.error) {
      toast.error("Something went wrong. Please try again.");
    }

    if (
      !deleteVehicleAPI.loading &&
      !deleteVehicleAPI.error &&
      deleteVehicleAPI.value
    ) {
      toast.success("Successfully removed vehicle.");
      dispatch(resetShowDeleteVehicleConfirmationModal());
    }
  }, [
    !!deleteVehicleAPI.error,
    !!deleteVehicleAPI.value,
    !!deleteVehicleAPI.loading,
  ]);

  const cancelDeletion = () => {
    dispatch(resetShowDeleteVehicleConfirmationModal());
  };

  const confirmDeletion = () => {
    if (!!showDeleteVehicleConfirmationModal) {
      dispatch(setVehicleToRemove(showDeleteVehicleConfirmationModal.id));
      dispatch(deleteVehicle(showDeleteVehicleConfirmationModal.id));
    }
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={cancelDeletion} style={modalStyles}>
      <div className="delete-vehicle-modal-container">
        <Close className="close-button" onClick={cancelDeletion} />

        <div className="title">Would you like to proceed?</div>

        <div className="buttons-container">
          <button
            type="submit"
            className="button secondary-button"
            disabled={deleteVehicleAPI.loading}
            onClick={cancelDeletion}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="button"
            disabled={deleteVehicleAPI.loading}
            onClick={confirmDeletion}
          >
            Delete
            {deleteVehicleAPI.loading && (
              <div style={{ marginLeft: 8 }}>
                <Oval
                  color="#131313"
                  height={20}
                  width={20}
                  secondaryColor="#FBD20A"
                />
              </div>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};
